export default __webpack_public_path__ + "static/123-ebba0195a75d0499f37ffbbc064b3d6e.gif";